// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import colors from 'vuetify/util/colors'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'


export default createVuetify({
  components: {
    VDateInput,
    VTimePicker
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#9900CC',
          secondary: '#1B1B1B',
          background: '#000000',
        },
      },
    },
  },
})
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
